import React from "react";
import { useI18n } from "../lib/i18n";

const SUPPORT_EMAIL = "kaviourapalvelut@gmail.com";

export default function Privacy() {
  const { t } = useI18n();

  const sections = [
    { key: "who", title: t("pp_who_title"), body: t("pp_who_body") },
    { key: "collect", title: t("pp_collect_title"), body: t("pp_collect_body") },
    { key: "use", title: t("pp_use_title"), body: t("pp_use_body") },
    { key: "legal", title: t("pp_legal_title"), body: t("pp_legal_body") },
    { key: "sharing", title: t("pp_sharing_title"), body: t("pp_sharing_body") },
    { key: "retention", title: t("pp_retention_title"), body: t("pp_retention_body") },
    { key: "rights", title: t("pp_rights_title"), body: t("pp_rights_body") },
    { key: "cookies", title: t("pp_cookies_title"), body: t("pp_cookies_body") },
    { key: "security", title: t("pp_security_title"), body: t("pp_security_body") },
    { key: "contact", title: t("pp_contact_title"), body: t("pp_contact_body") },
  ];

  return (
    <div data-testid="privacy-page" className="pt-28 pb-24 max-w-3xl mx-auto px-6">
      <div className="overline text-[#143122]">{t("pp_overline")}</div>
      <h1 className="mt-2 font-serif-display text-4xl md:text-5xl text-[#143122]">
        {t("pp_title")}
      </h1>
      <p className="mt-4 text-sm text-[#1A1F1C]/60">{t("pp_updated")}: 2026-07-12</p>
      <p className="mt-6 text-base text-[#1A1F1C]/85 leading-relaxed">{t("pp_intro")}</p>

      <div className="mt-12 space-y-10">
        {sections.map((s) => (
          <section key={s.key} data-testid={`pp-section-${s.key}`}>
            <h2 className="font-serif-display text-2xl text-[#143122]">{s.title}</h2>
            <p className="mt-3 text-sm text-[#1A1F1C]/85 leading-relaxed whitespace-pre-line">
              {s.body}
            </p>
          </section>
        ))}
      </div>

      <div className="mt-14 border-t border-[#E6E2D8] pt-8 text-sm text-[#1A1F1C]/70">
        {t("pp_contact_line")}{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}?subject=Kavioura%20privacy`}
          className="text-[#143122] underline"
        >
          {SUPPORT_EMAIL}
        </a>
      </div>
    </div>
  );
}
